/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateIWYSOnboardingFlow} from '../api'

export const useMutationInitiateIWYSOnboardingFlow = createReactQueryMutationHook('initiateIWYSOnboardingFlow', initiateIWYSOnboardingFlow)
